module.exports = __webpack_public_path__ + "img/logo.d2b69b1d.png";